// extracted by mini-css-extract-plugin
module.exports = {"container":"EVArticle-module--container--3kHba","topFont":"EVArticle-module--topFont--3cL9F","image":"EVArticle-module--image--2PcjR"};